import {api} from "../../services";
import Swal from "sweetalert2";

const notes = {
    state: {
      pagination: {
        data: [],
        page: 0,
        total: 0,
      },
        data: [],
        note: {}
    },
    getters: {
        getNoteObject: (state) => (key, value) => {
            const object = state.data.find(item => {
                return item[`${key}`] === value;
            });
            return object === undefined ? {} : object;
        },
        getNotesArray: (state) => (key, value) => {
            if (state.data !== undefined) {
                return state.data.filter(item => {
                    return item[`${key}`] === value;
                });
            }
            return [];
        },
    },
    mutations: {
        // SET_NOTES_PAGE(state, payload) {
        //     state.pagination.page = payload.page;
        //     state.pagination.total = payload.total;
        //     state.pagination.data = [...state.pagination.data, ...payload.data];
        //   },          
          RESET_NOTES_PAGINATION(state) {
            state.pagination = {
              data: [],
              page: 0,
              total: 0
            };
          },          
          
        SET_NOTES(state, payload) {
            state.pagination = payload
        },
        SET_NOTES_DATA(state, payload) {
            payload.forEach(p => {
                const exist = state.data.find(e => {
                    return e.id === p.id;
                });
                if (!exist) {
                    state.data.push(p);
                }
            });
        },
        SET_NOTE(state, payload) {
            state.note = payload
        },
    },
    actions: {
        async getNotesPage({ state, dispatch }, payload) {
            const lead_id = payload.lead_id;
            const page = payload.page || state.pagination.page + 1;

            try {
                const { data } = await api.get(`/notes`, {
                    params: { lead_id, page }
                });

                if (data?.data?.length) {
                    const combined = [...state.pagination.data, ...data.data];

                    // Remove duplicatas por ID
                    const seen = new Set();
                    const uniqueNotes = combined.filter(note => {
                        if (seen.has(note.id)) return false;
                        seen.add(note.id);
                        return true;
                    });

                    state.pagination.data = payload.replace ? data.data : uniqueNotes;
                    state.pagination.page = page;
                    state.pagination.total = data.total;
                }

            } catch (error) {
                if (error.response?.status === 401) {
                    dispatch('logoutUser');
                } else {
                    Swal.fire(
                        `${context.rootGetters.getTranslations('expression_406')}`,
                        `${error.response.data.message}`,
                        'warning'
                    );
                }
            }
        }
        ,
        //ROTA COM TOAST
        addNoteToast(context, payload) {
            api.post(`/notes`, payload).then(() => {
                context.commit("RESET_NOTES_PAGINATION"); // limpar tudo antes de recarregar

                context.dispatch('getNotesPage', {
                    lead_id: payload.lead_id,
                    page: 1,
                    replace: true // força substituir os dados atuais
                });

                Swal.fire({
                    icon: 'success',
                    title: context.rootGetters.getTranslations('expression_943'), // anotação adicionada
                    timer: 1500,
                    position: 'bottom-end',
                    toast: true,
                    showConfirmButton: false
                });
            }).catch(error => {
                if (error.response?.status === 401) {
                    context.dispatch('logoutUser');
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: context.rootGetters.getTranslations('expression_406'), // erro
                        toast: true,
                        position: 'bottom-middle',
                        showConfirmButton: false,
                        text: error.message || 'Falha na criação da nota',
                        timer: 2000
                    });
                }
            });
        },

        getNotes(context, payload) {
            api.get('/notes', {
                params: payload
            }).then(response => {
                context.commit("SET_NOTES", response.data);
            }).catch(error => {
                if (error.response.status === 401) {
                    this.dispatch('logoutUser');
                } else {
                    Swal.fire(
                      `${ context.rootGetters.getTranslations('expression_406')}`,
                      `${error.response.data.message}`,
                      'warning'
                    )
                }
            });
        },
        getNotesData(context, payload) {
            let ids = [];
            payload.forEach(p => {
                const item = context.state.data.find(i => {
                    return p === i.channel_id
                });
                if (item === undefined) {
                    ids.push(p);
                }
            });
            if (ids.length > 0) {
                api.post(`/notes`, {ids}).then(response => {
                    context.commit("SET_NOTES_DATA", response.data);
                }).catch(error => {
                    if (error.response.status === 401) {
                        this.dispatch('logoutUser');
                    } else {
                        Swal.fire(
                          `${ context.rootGetters.getTranslations('expression_406')}`,
                          `${error.response.data.message}`,
                          'warning'
                        )
                    }
                });
            }
        },
        getNotesAll(context) {
            api.get(`/notes/all`).then(response => {
                context.commit("SET_NOTES_DATA", response.data);
            }).catch(error => {
                if (error.response.status === 401) {
                    this.dispatch('logoutUser');
                } else {
                    Swal.fire(
                      `${ context.rootGetters.getTranslations('expression_406')}`,
                      `${error.response.data.message}`,
                      'warning'
                    )
                }
            });
        },
         
        addNote(context, payload) {
            api.post(`/notes`, payload).then(() => {
                if(payload.kanban_card_id){
                    this.dispatch('getNotes', {
                        lead_id: payload.lead_id,
                        kanban_card_id:payload.kanban_card_id
                    });
                } else {
                    this.dispatch('getNotes', {lead_id: payload.lead_id})
                }
                
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: context.rootGetters.getTranslations('expression_943'),
                    showConfirmButton: false,
                    timer: 1500
                })
            }).catch(error => {
                if (error.response.status === 401) {
                    this.dispatch('logoutUser');
                } else {
                    Swal.fire(
                      `${ context.rootGetters.getTranslations('expression_406')}`,
                      `${error.response.data.message}`,
                      'warning'
                    )
                }
            });
        },
        updateNote(context, payload) {
            api.put(`/notes/${payload.id}`, payload).then(response => {
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: context.rootGetters.getTranslations('expression_944'),
                    showConfirmButton: false,
                    timer: 1500
                })
            }).catch(error => {
                if (error.response.status === 401) {
                    this.dispatch('logoutUser');
                } else {
                    Swal.fire(
                      `${ context.rootGetters.getTranslations('expression_406')}`,
                      `${error.response.data.message}`,
                      'warning'
                    )
                }
            });
        },
        deleteNote(context, payload) {
            api.delete(`/notes/${payload.id}`).then(() => {
                this.dispatch('getNotes', payload.channel_id)
                Swal.fire(
                    `${ context.rootGetters.getTranslations('expression_906') }`,
                    `${ context.rootGetters.getTranslations('expression_945') }`,
                    'success'
                )
            }).catch(error => {
                if (error.response.status === 401) {
                    this.dispatch('logoutUser');
                } else {
                    Swal.fire(
                      `${ context.rootGetters.getTranslations('expression_406')}`,
                      `${error.response.data.message}`,
                      'warning'
                    )
                }
            });
        },
    },
}
export default notes;
